import React, {useState} from 'react';
import {PauseIcon, PlayIcon} from 'lucide-react';
import {ToolButton, Toolbar} from '../ds/ToolFrame.tsx';

interface VideoToolbarProps {
    controlsDisabled: boolean;
    playSelectedVideo: () => void;
    pauseSelectedVideo: () => void;
}

const VideoToolbar: React.FC<VideoToolbarProps> = ({
    controlsDisabled,
    playSelectedVideo,
    pauseSelectedVideo
}) => {
    const [isVideoPlay, setIsVideoPlay] = useState(true);
    const onPlayClick = () => {
        playSelectedVideo();
        setIsVideoPlay(true);
    };
    const onPauseClick = () => {
        pauseSelectedVideo();
        setIsVideoPlay(false);
    };
    return (
        <Toolbar label="Video" className="whiteboard-toolbar">
            <ToolButton
                label="Play"
                icon={PlayIcon}
                selected={isVideoPlay}
                disabled={controlsDisabled}
                onClick={onPlayClick}
            />
            <ToolButton
                label="Pause"
                icon={PauseIcon}
                selected={!isVideoPlay}
                disabled={controlsDisabled}
                onClick={onPauseClick}
            />
        </Toolbar>
    );
};

export default VideoToolbar;
